import React from 'react';
import styled from 'styled-components';
import { RateCardModel } from '@utmost.co/enterprise-models';
import { StatusChipType, StatusChip } from '@beeline.com/bp-design-system';

interface Props {
  rateCard?: RateCardModel;
}
const LocationDetails: React.FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const hasLocations = (rateCard?.businessSiteOverrides?.length ?? 0) > 0;
  return (
    <>
      {hasLocations
        ? rateCard?.businessSiteOverrides?.map((l) => (
            <StyledLocation key={l.name}>
              <StatusChip key={l.name} label={l.name} type={StatusChipType.GREY} />
            </StyledLocation>
          ))
        : '-'}
    </>
  );
};
export default LocationDetails;
const StyledLocation = styled.div`
  margin: 0.25rem;
  width: fit-content;
`;
